export const toNumber = (value) => {
  const number = parseFloat(value);
  return Number.isFinite(number) ? number : 0;
};

export const calculateCartTotal = (cart) =>
  (Array.isArray(cart) ? cart : []).reduce(
    (total, item) =>
      total + (toNumber(item.total) + toNumber(item.optPrice)) * toNumber(item.quantity),
    0
  );

export const calculateOrdersTotal = (orders) =>
  (Array.isArray(orders) ? orders : []).reduce(
    (total, order) => total + toNumber(order.total),
    0
  );

export const applyDiscount = (amount, discountRate) => {
  const total = toNumber(amount);
  return discountRate ? total * (1 - toNumber(discountRate) / 100) : total;
};

export const calculateDiscountTotal = (orders) =>
  (Array.isArray(orders) ? orders : []).reduce(
    (total, order) => total + toNumber(order.discountAmount),
    0
  );

export const calculateOptionsPrice = (options, portion) =>
  (Array.isArray(options) ? options : []).reduce(
    (total, option) => total + toNumber(option.price),
    0
  ) +
  toNumber(portion?.price);

export const calculatePaymentsTotal = (payments) =>
  (Array.isArray(payments) ? payments : []).reduce(
    (total, payment) => total + toNumber(payment.amount),
    0
  );

export const calculateSelectedItemsTotal = (selectedItems, menuById = {}) =>
  Object.values(selectedItems || {}).reduce((total, selectedItem) => {
    if (!selectedItem) return total;

    const mealPrice = toNumber(menuById?.[selectedItem.mealId]?.price);
    return (
      total +
      (mealPrice + toNumber(selectedItem.optPrice)) *
        toNumber(selectedItem.quantity)
    );
  }, 0);

export const selectAllOrderItems = (orders) =>
  (Array.isArray(orders) ? orders : []).reduce((selectedItems, order) => {
    order.cart?.forEach((cartItem) => {
      if (toNumber(cartItem.quantity) > 0) {
        selectedItems[cartItem.id] = {
          orderId: order.id,
          quantity: cartItem.quantity,
          maxQuantity: cartItem.quantity,
          mealId: cartItem.meal,
          optPrice: cartItem.optPrice,
        };
      }
    });
    return selectedItems;
  }, {});
